module.exports = __webpack_public_path__ + "img/1528855821.14c6fad9.jpg";